/* Zumpo/Sound menu: the name menu's 320 px paper card, lifted. */
.menu {
  display: flex;
  flex-direction: column;
  gap: var(--zumpo-space-16);
  box-sizing: border-box;
  width: 320px;
  padding: var(--zumpo-space-32);
  border-radius: var(--zumpo-radius-24);
  border: 1px solid var(--zumpo-line);
  background: var(--zumpo-paper);
  /* A border, as Figma's stroke takes a pixel inside the padding: 146 tall. */
  box-shadow: var(--zumpo-shadow-menu-lift);
  outline: none;
  transition:
    opacity 150ms ease-out,
    transform 150ms ease-out;
}

.menu[data-starting-style],
.menu[data-ending-style] {
  opacity: 0;
  transform: translateY(-4px);
}

/* On the design system's page, where no trigger is above it. */
.still {
  transition: none;
}

.row {
  display: flex;
  flex-direction: column;
  gap: var(--zumpo-space-12);
}

.head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--zumpo-space-12);
  font: var(--zumpo-text-label);
  letter-spacing: var(--zumpo-text-label-tracking);
}

.label {
  color: var(--zumpo-ink);
}

.level {
  color: var(--zumpo-muted);
}

.control {
  display: flex;
  align-items: center;
  gap: var(--zumpo-space-12);
}

.slider {
  flex: 1;
  min-width: 0;
}

@media (prefers-reduced-motion: reduce) {
  .menu {
    transition: none;
  }
}

/* SO04: the width of the screen less its 16 px margins. */
@media (max-width: 640px) {
  .menu {
    width: calc(100vw - 2 * var(--zumpo-space-16));
  }

  .still {
    width: 100%;
  }
}
